module.exports = __webpack_public_path__ + "media/images/products/2-38e8429bc9973445326bfb98beb03030.jpg";